import React, { useState, useEffect } from "react";
import "./detailpage.css";

import gynaeBanner from "../../images/gynae-drape-banner.webp";
import gynaeone from "../../images/pdpimage/gynaeone.jpg";
import gynaetwo from "../../images/pdpimage/gynaetwo.jpg";
import gynaethree from "../../images/pdpimage/gynaethree.jpg";
import gynaefour from "../../images/pdpimage/gynaefour.jpg";

const whatsappNumber = "+919619065205";

const PRODUCT_IMAGES = [
  { id: "gyn1", src: gynaeone, alt: "Gynae Drape - Full View" },
  { id: "gyn2", src: gynaetwo, alt: "Gynae Drape - Fluid Pouch Close-Up" },
  { id: "gyn3", src: gynaethree, alt: "Gynae Drape - Adhesive Zone" },
  { id: "gyn4", src: gynaefour, alt: "Gynae Drape - Folded Packaging" },
];

const ContactBanner = () => (
  <div className="contact-banner">
    <h3>Need guidance choosing the right drape?</h3>
    <p>Our clinical support team is here to assist you.</p>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Bulk Quote
    </a>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Brochure
    </a>
  </div>
);

const GynaeDrape = () => {
  useEffect(() => {
    document.title = "Gynae Drape - Secure & Hygienic Draping for Obstetric Procedures";
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const mainImage = PRODUCT_IMAGES[activeIndex];

  return (
    <>
      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${gynaeBanner})`,
        }}
      >
        <h1 className="homepage-hero-title">Gynae Drape</h1>
        <p className="homepage-hero-subtext">
          Secure and Hygienic Draping for Obstetric & Gynecological Procedures
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Bulk Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>

      {/* Product Overview with Simple Gallery */}
      <section className="mw-product-details mw-container">
        <div className="mw-gallery">
          {/* Main Image */}
          <div className="mw-gallery-main">
            <img
              src={mainImage.src}
              alt={mainImage.alt}
              className="main-gallery-image"
            />
          </div>

          {/* Thumbnails */}
          <div className="mw-gallery-thumbs">
            {PRODUCT_IMAGES.map((img, index) => (
              <div
                key={img.id}
                className={`gallery-thumb-img-box ${index === activeIndex ? "active-thumb" : ""}`}
                onClick={() => setActiveIndex(index)}
              >
                <img src={img.src} alt={img.alt} loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        {/* Product Info */}
        <div className="mw-product-info" id="contact">
          <h2 className="homepage-section-title">Product Overview</h2>
          <p>
            Our Gynae Drapes are designed to support gynecological and obstetric
            surgeries by providing maximum patient coverage, fluid management,
            and ease of access to the operative area. Reinforced fenestration
            and secure adhesion ensure a sterile and efficient surgical
            environment.
          </p>
          <ul className="mw-list">
            <li>U-cut or oval fenestration options</li>
            <li>Absorbent zones and integrated fluid pouch</li>
            <li>Adhesive tape for easy positioning</li>
            <li>Soft SMS/SMMS material for patient comfort</li>
            <li>Sterile single-use packaging</li>
          </ul>

          <h2 className="homepage-section-title">Technical Specifications</h2>
          <table className="mw-specs-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Material</td>
                <td>SMS/SMMS with PE backing and fluid pouch</td>
              </tr>
              <tr>
                <td>Size</td>
                <td>200 x 180 cm / 220 x 200 cm (customizable)</td>
              </tr>
              <tr>
                <td>Fenestration</td>
                <td>U-cut / Oval with reinforcement</td>
              </tr>
              <tr>
                <td>Sterility</td>
                <td>EO Sterilized</td>
              </tr>
              <tr>
                <td>Packaging</td>
                <td>Individually packed; 25 pcs/carton</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Compliance */}
      <section className="mw-compliance">
        <h2 className="homepage-section-title">Certifications & Standards</h2>
        <ul className="mw-cert-list">
          <li>
            <span className="checkmark">✅</span>
            <span>ISO 13485:2016</span>
          </li>
          <li>
            <span className="checkmark">✅</span>
            <span>EN 13795 High Performance</span>
          </li>
          <li>
            <span className="checkmark">✅</span>
            <span>MDR Compliant</span>
          </li>
        </ul>
      </section>

      {/* Footer CTA */}
      <ContactBanner />
    </>
  );
};

export default GynaeDrape;
